import AddressesView from './AddressesView';

export default AddressesView;
